// extracted by mini-css-extract-plugin
var _1 = "top-level-page__zseQF";
export { _1 as "topLevelPage" }
